import { saveGame } from "./lib/save";
import { setMusicEra, unlockAudio } from "./lib/sound";
import { dateOf } from "@bd/sim";
import { useEffect } from "react";
import { useGame } from "./store";
import { World } from "./world/World";
import { BrandAndProjects, BuildCard, Clock, Dock, Resources, RoomCard, LotCard, Toasts, Tray, useHotkeys, SpeedFab } from "./ui/Hud";
import { TitleScreen } from "./ui/Title";
import { Gran } from "./ui/Gran";
import { Screens } from "./screens/Screens";
import { Closeup } from "./world/Closeup";
import { Lobby } from "./online/Lobby";
import { QuarterBar } from "./online/QuarterBar";
import { VisitBanner } from "./online/VisitBanner";

export function App() {
  useEffect(() => {
    // browsers only allow sound after a click or key press
    const go = () => unlockAudio();
    window.addEventListener("pointerdown", go, { once: true });
    window.addEventListener("keydown", go, { once: true });
    return () => {
      window.removeEventListener("pointerdown", go);
      window.removeEventListener("keydown", go);
    };
  }, []);
  const eraId = useGame((s) => (s.game ? dateOf(s.game.week).era.id : "parlour"));
  useEffect(() => setMusicEra(eraId), [eraId]);
  const game = useGame((s) => s.game);
  const closeup = useGame((s) => s.closeup);
  const screen = useGame((s) => s.screen);
  // close-ups take the whole screen, like the mock: their own title card, readout and key hints
  const full = !!closeup || screen?.kind === "playtest" || screen?.kind === "launch" || screen?.kind === "finale";
  const textScale = useGame((s) => s.textScale);
  // a language switch redraws the whole interface
  useGame((s) => s.lang);
  const lobby = useGame((s) => s.lobby);
  const online = useGame((s) => !!s.online);
  const visiting = useGame((s) => s.visiting);
  useHotkeys();
  useEffect(() => {
    const save = () => {
      const g = useGame.getState().game;
      if (g && !g.finished) void saveGame("autosave", g).catch(() => undefined);
    };
    const onHide = () => document.visibilityState === "hidden" && save();
    document.addEventListener("visibilitychange", onHide);
    window.addEventListener("pagehide", save);
    return () => {
      document.removeEventListener("visibilitychange", onHide);
      window.removeEventListener("pagehide", save);
    };
  }, []);
  useEffect(() => {
    document.documentElement.style.setProperty("--text-scale", String(textScale));
  }, [textScale]);
  return (
    <>
      <World />
      {!game && (lobby ? <Lobby /> : <TitleScreen />)}
      {game && (
        <>
          {closeup ? <Closeup roomId={closeup} /> : null}
          {!full && !visiting && <BrandAndProjects />}
          {visiting && <VisitBanner />}
          {!full && <Resources />}
          {online ? <QuarterBar /> : <Clock />}
          {!full && !visiting && <RoomCard />}
          {!full && !visiting && <LotCard />}
          {!full && !visiting && <Tray />}
          {!full && !visiting && <BuildCard />}
          {!full && !visiting && <Dock />}
          {!full && !visiting && !online && <SpeedFab />}
          <Toasts />
          <Screens />
          <Gran />
        </>
      )}
    </>
  );
}
